import { renderComponent } from './components/ProductPayWithCoinsCard';

const domContainer1 = document.querySelector('#pay-with-coins-card-1');
renderComponent(domContainer1);
